import useActionsTechnologyAdvancedForm from './useActionsTechnologyAdvancedForm'

export default useActionsTechnologyAdvancedForm
